var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.fields),function(field){return _c('field-item',{key:field.id,attrs:{"field":field},on:{"edit":function($event){return _vm.$emit('edit-field', field)},"copy":function($event){return _vm.$emit('copy-field', field)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }